// src/pages/Onboarding/OnboardingContact.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { sendOtp } from "../../services/api";

const OnboardingContact = () => {
  const [contact, setContact] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      const response = await sendOtp(contact.trim());
      localStorage.setItem("contact", contact.trim());
      if (response?.pending_id) {
        localStorage.setItem("pending_id", String(response.pending_id));
      }
      alert(response?.message || "OTP sent");
      navigate("/onboarding/verify");
    } catch (err) {
      alert(err.message || "Failed to send OTP");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100 px-4 py-12">
      <form onSubmit={handleSubmit} className="w-full max-w-md rounded-2xl bg-white p-8 shadow-xl">
        <h2 className="text-2xl font-semibold text-slate-900">Step 1: Contact details</h2>
        <p className="mt-2 text-sm text-slate-500">
          Enter the email address or phone number you want to use for your Ecoops Wealth account.
        </p>

        <div className="mt-6 space-y-2">
          <label className="text-sm font-medium text-slate-700" htmlFor="contact">
            Email or phone number
          </label>
          <input
            id="contact"
            type="text"
            value={contact}
            onChange={(event) => setContact(event.target.value)}
            required
            className="w-full rounded-lg border border-slate-200 px-4 py-3 text-slate-900 shadow-sm focus:border-emerald-500 focus:outline-none focus:ring-2 focus:ring-emerald-100"
            placeholder="you@example.com"
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          className="mt-6 w-full rounded-lg bg-emerald-600 px-4 py-3 text-sm font-semibold text-white shadow-lg shadow-emerald-600/20 transition hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-emerald-300 disabled:cursor-not-allowed disabled:bg-emerald-400"
        >
          {loading ? "Sending..." : "Send OTP"}
        </button>
      </form>
    </div>
  );
};

export default OnboardingContact;
